import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const scrollToEl = (el) => {
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const HtmlBlock = ({ html, onAnchor, testId }) => {
  const navigate = useNavigate();
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root || !root.firstElementChild) return;
    const sections = Array.from(root.firstElementChild.children);
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add("rv-in"); obs.unobserve(en.target); }
      });
    }, { threshold: 0.06 });
    sections.forEach((el) => {
      const st = el.getAttribute("style") || "";
      if (st.includes("position:sticky")) return;
      el.classList.add("rv");
      obs.observe(el);
    });
    return () => obs.disconnect();
  }, [html]);

  const handleClick = (e) => {
    const a = e.target.closest("a");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    if (href.startsWith("#")) {
      e.preventDefault();
      if (onAnchor && onAnchor(href, a)) return;
      const el = document.getElementById(href.slice(1));
      if (el) scrollToEl(el);
    } else if (href.startsWith("/")) {
      e.preventDefault();
      navigate(href);
    }
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      onClickCapture={handleClick}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
